import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Store для управления историей чата с ИИ
 * Сохраняет сообщения между переходами по страницам
 */
export const useChatStore = defineStore('chat', () => {
  // ========== Сообщения ==========
  const messages = ref([])
  const isLoading = ref(false)
  const currentQuery = ref('')

  // ========== Методы ==========
  
  /**
   * Добавить сообщение пользователя
   */
  function addUserMessage(text) {
    messages.value.push({
      type: 'user',
      text,
      timestamp: new Date().toISOString()
    })
    trimMessages()
  }

  /**
   * Добавить сообщение от ИИ
   */
  function addAiMessage({ text, sql, results, error, download_token, export_filename }) {
    const message = {
      type: 'ai',
      timestamp: new Date().toISOString()
    }

    if (text) message.text = text
    if (sql) message.sql = sql
    if (error) message.error = error
    if (download_token) message.download_token = download_token
    if (export_filename) message.export_filename = export_filename
    
    // Для результатов сохраняем только превью (первые 50 строк)
    if (results) {
      if (Array.isArray(results) && results.length > 50) {
        message.results = results.slice(0, 50)
        message.resultsPreview = true
        message.totalResults = results.length
      } else {
        message.results = results
      }
    }

    messages.value.push(message)
    trimMessages()
  }

  /**
   * Ограничить количество сообщений
   */
  function trimMessages() {
    if (messages.value.length > 50) {
      messages.value = messages.value.slice(-50)
    }
  }

  /**
   * Очистить всю историю
   */
  function clearHistory() {
    messages.value = []
    currentQuery.value = ''
  }

  return {
    // State
    messages,
    isLoading,
    currentQuery,

    // Methods
    addUserMessage,
    addAiMessage,
    trimMessages,
    clearHistory
  }
}, {
  // Персистентность: сохраняем последние сообщения
  persist: {
    key: 'ai-database-chat',
    storage: sessionStorage,
    paths: [
      'messages'
    ],
    // Сериализация для больших объектов
    serializer: {
      serialize: (state) => {
        // Сохраняем только превью результатов для экономии места
        const lightState = {
          ...state,
          messages: state.messages.map(msg => {
            if (msg.type === 'ai' && msg.results && Array.isArray(msg.results) && msg.results.length > 10) {
              return {
                ...msg,
                results: msg.results.slice(0, 10),
                resultsPreview: true,
                totalResults: msg.results.length
              }
            }
            return msg
          })
        }
        return JSON.stringify(lightState)
      },
      deserialize: JSON.parse
    }
  }
})
